import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.cases'),
    id: 'globalCases',
    sidebar: [
        {
            id: 'regimes',
            label: i18n.tc('configuration.sections.regimes', 2),
            icon: 'fal fa-procedures',
            routeName: 'CaseRegimes',
            hasChildren: false
        },
        {
            id: 'procedures',
            label: i18n.tc('configuration.sections.priorities', 2),
            icon: 'fal fa-flag',
            routeName: 'CasePriorities',
            hasChildren: false
        },
        {
            id: 'caseTypes',
            label: i18n.tc('configuration.sections.caseTypes', 2),
            icon: 'fal fa-chart-network',
            routeName: 'CaseTypes',
            hasChildren: false
        },
        {
            id: 'caseInsurers',
            label: i18n.tc('configuration.sections.insurer', 2),
            icon: 'fal fa-shield',
            routeName: 'CaseInsurers',
            hasChildren: false
        }
    ]
}
